import React, { useState, useEffect } from 'react';
import GetMonths from '../../../Dropdowns/getMonths';
import GetYears from '../../../Dropdowns/getYears';
import CircularProgress from '@mui/material/CircularProgress';
import Trans_Data_Abstract from './Trans_Data_Abstract';

const TransDataInt = ({ heading }) => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [loadingMonths, setLoadingMonths] = useState(true);
  const [loadingYears, setLoadingYears] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const handleMonthsLoadingChange = (isLoading) => setLoadingMonths(isLoading);
  const handleYearsLoadingChange = (isLoading) => setLoadingYears(isLoading);

  const handleSubmit = () => {
    const selectedMonth = document.getElementById('month').value;
    const selectedYear = document.getElementById('year').value;

    if (!selectedMonth || selectedMonth === '0') {
      alert('Please select Month');
      return;
    }
    if (!selectedYear || selectedYear === '0') {
      alert('Please select Year');
      return;
    }

    setMonth(selectedMonth);
    setYear(selectedYear);

    setLoading(true);
    setShowTable(false);

    setTimeout(() => {
      setLoading(false);
      setShowTable(true);
    }, 3000);
  };

  return (
    <div className="wrapper row3">
      <div id="container">
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <table width="40%">
            <thead>
              <tr className="tableheader">
                <th colSpan={8}>{heading}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Month</td>
                <td>
                  <GetMonths onLoadingChange={handleMonthsLoadingChange} />
                </td>
                <td>Year</td>
                <td>
                  <GetYears onLoadingChange={handleYearsLoadingChange} />
                </td>
              </tr>
              <tr>
                <td colSpan={8} align="center">
                  <button
                    onClick={handleSubmit}
                    className="button button2"
                    disabled={loadingMonths || loadingYears || loading}
                  >
                    Submit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        {loading && (
          <div
            align="center"
            id="loading"
            style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
          >
            <CircularProgress />
          </div>
        )}

        {showTable && month && year && (
          <div style={{ marginTop: '20px' }}>
            <Trans_Data_Abstract month={month} year={year} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TransDataInt;
